//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/assets/css/reset.css";
import "@/assets/css/global.css";
export default {
  components: {

  },

  props: ["dataConfig"],

  data() {
    return {
      //powerScanner: null,
      IsRefreshUI: true,

      //dataConfig: null,

      //OrderOpenId: "",
      //StockOrderType = 0;
      //88,门店库存盘点单
      //StockOrderType: 88,
      //RMS_PassageUser id=112864
      //PassageUserOpenId: "20ce6b4998b544609325704a5935de41",
      //RMS_PassageNode id=407485
      //PassageNodeOpenId: "2d6ac4777db949a1afccec40fb0aafad",

      WaitScanCodeList: [],
      ScanCodeList: [],
      FailedScanCodeList: [],
      ProductDetailList: [],
    };
  },

  async created() {
    //this.powerScanner.scan("http://ysl.entfly.com/mYslPms/ProductSn?sn=00471750300018069012");
  },

  async mounted() {

    console.log("mounted.....",this.dataConfig);    

    //this.dataConfig = this.getScanConfig();
    //this.setConfig(dataConfig);
    await this.$init();
    await this.$checkSync();
  },

  methods: {

    $getOrderOpenId(){      
      return this.dataConfig.OrderOpenId;      
    },

    $getSubmitData(){
      var formData = {};
      formData.OrderOpenId = this.dataConfig.OrderOpenId;
      formData.StockOrderType = this.dataConfig.StockOrderType;
      formData.PassageUserOpenId = this.dataConfig.PassageUserOpenId;
      formData.PassageNodeOpenId = this.dataConfig.PassageNodeOpenId;
      return formData;      
    },

    // getScanConfig() {
    //   var dataConfig = {
    //     InitUrl: "mTplApi/ShopStockCheckOrder/Init",
    //     ClearUrl: "mTplApi/ShopStockCheckOrder/Clear",
    //     ClearFailedScanCodeListUrl:
    //       "mTplApi/ShopStockCheckOrder/ClearFailedScanCodeList",
    //     DeleteFailedScanCodeListUrl:
    //       "mTplApi/ShopStockCheckOrder/DeleteFailedScanCodeList",
    //     DeleteScanCodeListUrl: "mTplApi/ShopStockCheckOrder/DeleteScanCodeList",
    //     SubmitUrl: "mTplApi/ShopStockCheckOrder/Submit",
    //     ScanCodeUrl: "mTplApi/ShopStockCheckOrder/ScanCode2"
    //   };
    //   return dataConfig;
    // },

    
    onTestClick() {
      this.addScanCode(
        "http://ysl.entfly.com/mYslPms/ProductSn?sn=00471750300018069012"
      );
    },
    
    onClearFailedCodeClick() {
      this.$clearFailedScanCode();
    },

    onRefreshClick() {
      this.$refreshData();
    },

    onClearClick() {
      this.$clearData();
    },

    onDeleteScanCodeClick(scanCode) {
      console.log(scanCode.Code, "删除");
      this.$deleteScanCode(scanCode.Code);
    },


    onDeleteFailedScanCodeClick(scanCode) {
      console.log(scanCode.Code, "删除");
      this.$deleteFailedScanCode(scanCode.Code);
    },

    setConfig(dataConfig) {
      this.dataConfig = dataConfig;
    },
    

    $getPostData(postData) {
      if (!postData) {
        postData = {};
      }
      postData.OrderOpenId = this.dataConfig.OrderOpenId;
      postData.StockOrderType = this.dataConfig.StockOrderType;
      postData.PassageUserOpenId = this.dataConfig.PassageUserOpenId;
      postData.PassageNodeOpenId = this.dataConfig.PassageNodeOpenId;
      return postData;
    },

    async $init() {
      //var url = "mSmsApi/ShopStockInOrder/Init";
      var url = this.dataConfig.InitUrl;

      var postData = this.$getPostData();
      console.log("$init---postData",postData);
      this.$msg.showLoading();
      var result = await this.$web.post(url, postData);
      this.$msg.hideLoading();
      if (result.state == 1) {
        this.$msg.succ();
        var resultData = result.data;
        if (resultData) {
          this.dataConfig.OrderOpenId = resultData.OrderOpenId;
          if(resultData.StockOrderType){
            this.dataConfig.StockOrderType = resultData.StockOrderType;
          }
          if(this.dataConfig.PassageUserOpenId){
            this.dataConfig.PassageUserOpenId = resultData.PassageUserOpenId;
          }
          if(resultData.PassageNodeOpenId){
            this.dataConfig.PassageNodeOpenId = resultData.PassageNodeOpenId;
          }
        }
        this.$reloadScanCode(resultData);
        return;
      }
      this.$msg.alert(result.msg);
    },
    
    $resetData() {
      this.WaitScanCodeList = [];
      this.ScanCodeList = [];
      this.FailedScanCodeList = [];
      this.ProductDetailList = [];
    },

    $refreshUI() {
      this.IsRefreshUI = false;
      this.IsRefreshUI = true;

      // console.log("ScanCodeList", this.ScanCodeList);
      // console.log("FailedScanCodeList", this.FailedScanCodeList);
      // console.log("ProductDetailList", this.ProductDetailList);

      // console.log("$refreshUI");
    },    

    async $refreshData() {
      //var url = "mSmsApi/ShopStockInOrder/Init";
      this.$resetData();
      await this.$init();
    },
    
    async $clearData() {
      //var url = "mSmsApi/ShopStockInOrder/Clear";
      var url = this.dataConfig.ClearUrl;
      var postData = this.$getPostData();
      this.$msg.showLoading();
      var result = await this.$web.post(url, postData);
      this.$msg.hideLoading();
      if (result.state == 1) {
        this.$msg.succ();
        this.$resetData();
        this.$refreshUI();
        return;
      }
    },


    async $checkSync() {
      console.log("$checkSync", new Date().toString());
      var scanner = this;
      setTimeout(async () => {
        try {
          await scanner.$syncData();

          setTimeout(async () => {
            await scanner.$checkSync();
          }, 2000);
        } catch (e) {
          console.log("error:", e);
          await scanner.$syncData();
        }
      }, 2000);
    },

    //var isLoading = false;
    async $syncData(isAsync) {
      // try {
      //this.showSyncLoading();
      //var WaitScanCodeList = this.getSyncList(false);
      if (!this.WaitScanCodeList || this.WaitScanCodeList.length == 0) {
        //$.toast("当前没有需要同步的数据.", "forbidden");
        //$.toptip('检测同步...', 500, 'success');
        //this.hideSyncLoading();
        return false;
      }

      if ("undefined" == typeof isAsync) {
        isAsync = true;
      }

      // this.showSyncLoading();

      var scanCodeList = this.WaitScanCodeList.map(m => {
        return m.Code;
      });
      var url = this.dataConfig.ScanCodeUrl;
      var postData = this.$getPostData();
      postData.scanCodeList = scanCodeList;

      //$.showLoading("");
      //$.toptip('正在同步...', 10000, 'warning');
      //alert(url);
      this.$msg.showLoading();
      var result = await this.$web.post(url, postData);
      this.$msg.hideLoading();
      if (result.state == 1) {
        this.$msg.succ();
        //$.toast(result.msg);
        var resultData = result.data;
        this.$reloadScanCode(resultData);
        return;
      }
      this.$msg.alert(result.msg);
      // } catch (e) {
      //   alert("error:" + e);
      //   return false;
      // }
    },

    addScanCode(scanCode) {
      console.log("scan", scanCode);
      return this.addWaitScanCode(scanCode);
    },    


    getScanCodeList() {
      var formatCodeList = [];
      this.ScanCodeList.map(item => {
        formatCodeList.push(item.FormatCode);
      });
      return formatCodeList;
    },

    addWaitScanCode(scanCode) {
      if (this.WaitScanCodeList.some(m => m.Code == scanCode)) return null;
      var scanCodeItem = {
        Code: scanCode,
        IsCheck: false
      };
      this.WaitScanCodeList.push(scanCodeItem);
      return scanCodeItem;
    },

    removeWaitScanCode(scanCode) {
      this.WaitScanCodeList.forEach((m, index, list) => {
        if (m.Code == scanCode) {
          list.splice(index, 1);
        }
      });
    },

    addScanCodeItem(scanCodeItem) {
      
      if (this.ScanCodeList.some(m => m.Code == scanCodeItem.Code)){
        return false;
      }

      console.log("this.ScanCodeList000",this.ScanCodeList);
            console.log("this.scanCodeItem000===",scanCodeItem);

      this.ScanCodeList.push(scanCodeItem);
      //this.ScanCodeList.reverse();
      return true;
    },

    removeScanCodeItem(scanCode) {
      this.ScanCodeList.forEach((m, index, list) => {
        if (m.Code == scanCode) {
          list.splice(index, 1);
        }
      });
    },

    removeFailedScanCodeItem(scanCode) {
      this.FailedScanCodeList.forEach((m, index, list) => {
        if (m.Code == scanCode) {
          list.splice(index, 1);
        }
      });
    },

    getScanCodeItem(code) {
      if (!code) {
        return null;
      }
      if (this.ScanCodeList.length === 0) return false;
      var scanCodeItem = this.ScanCodeList.filter(m => m.Code == code);
      return scanCodeItem;
    },

    addFailedScanCodeItem(scanCodeItem) {
      if (this.FailedScanCodeList.some(m => m.Code == scanCodeItem.Code))
        return false;
      this.FailedScanCodeList.push(scanCodeItem);
      return true;
    },

    getFailedScanCodeItem(code) {
      if (!code) {
        return null;
      }
      if (!this.FailedScanCodeList || this.FailedScanCodeList.length === 0)
        return false;

      var scanCodeItem = this.FailedScanCodeList.filter(m => m.Code == code);
      return scanCodeItem;
    },

    containsProductDetail(productId) {
      return this.ProductDetailList.some(m => m.ProductId == productId);
    },

    getProductDetailItem(productId) {
      return this.ProductDetailList.filter(m => m.ProductId == productId);
    },

    addProductDetailItem(productDetailItem) {

      if(!productDetailItem) return null;
      console.log("productDetailItem",productDetailItem);

      var index = -1;
      for (var i = 0; i < this.ProductDetailList.length; i++) {
        if (this.ProductDetailList[i].ProductId == productDetailItem.ProductId) {
          index = i;
          break;
        }
      }

      if (index != -1) {
        this.ProductDetailList.splice(index, 1, productDetailItem);
      } else {
        this.ProductDetailList.push(productDetailItem);
      }

      console.log("this.ProductDetailList",this.ProductDetailList);
      return true;
    },
    

    async $clearFailedScanCode() {
      var url = this.dataConfig.ClearFailedScanCodeListUrl;
      var postData = {
        orderOpenId: this.dataConfig.OrderOpenId
      };
      this.$msg.showLoading();
      var result = await this.$web.post(url, postData);
      this.$msg.hideLoading();
      console.log(result, "result");
      if (result.state == 1) {
        this.$msg.succ();
        this.FailedScanCodeList = [];
        return;
      }
    },

    async $deleteFailedScanCode(scanCode) {
      if (!scanCode) {
        return;
      }
      var url = this.dataConfig.DeleteFailedScanCodeListUrl;
      var postData = this.$getPostData();
      postData.scanCodeList = [scanCode];
      this.$msg.showLoading();
      var result = await this.$web.post(url, postData);
      this.$msg.hideLoading();
      console.log(result, "result");
      if (result.state == 1) {
        this.$msg.succ();
        var resultData = result.data;
        this.$reloadScanCode(resultData);
        return;
      }
    },

    

    async $deleteScanCode(scanCode) {
      if (!scanCode) {
        return;
      }

      var postData = this.$getPostData();
      postData.scanCodeList = [scanCode];

      var url = this.dataConfig.DeleteScanCodeListUrl;
      this.$msg.showLoading();
      var result = await this.$web.post(url, postData);
      this.$msg.hideLoading();
      if (result.state == 1) {
        this.$msg.succ();
        //await this.$init();
        var resultData = result.data;
        this.ProductDetailList = [];
        this.$reloadScanCode(resultData);
        return;
      }
    },

    async submit() {
      var url = this.dataConfig.SubmitUrl;
      var postData = this.$getPostData();
      var result = await this.$web.post(url, postData);
      return result;
    },

    showSyncLoading(text) {
      if (!text) {
        text = "正在同步...";
      }
      //$("#syncTipText", $("#divSync")).html(text);
      //$("#divSync").show();
    },

    hideSyncLoading() {
      //$("#divSync").hide();
    },

    $reloadScanCode(resultData) {
      if (!resultData) return false;
      if (resultData.ScanCodeList && resultData.ScanCodeList.length > 0) {

        resultData.ScanCodeList.forEach(m => {

          var scanCode = m.Code;
          if (!m.FormatCode) {
            this.removeWaitScanCode(scanCode);
            return;
          }

          var scanCodeItem = this.getScanCodeItem(scanCode);

          if (!scanCodeItem || !scanCodeItem.Code) {
            scanCodeItem = m;
          }
          this.addScanCodeItem(scanCodeItem);
          this.removeWaitScanCode(scanCode);
        });
        this.$refreshUI();
      }

      if (
        resultData.FailedScanCodeList &&
        resultData.FailedScanCodeList.length > 0
      ) {
        resultData.FailedScanCodeList.forEach(m => {
          var scanCode = m.Code;
          if (!m.FormatCode) {
            this.removeWaitScanCode(scanCode);
            return;
          }

          var scanCodeItem = this.getFailedScanCodeItem(scanCode);
          if (!scanCodeItem || !scanCodeItem.Code) {
            scanCodeItem = m;
          }
          this.addFailedScanCodeItem(scanCodeItem);
          this.removeWaitScanCode(scanCode);
        });
        this.$refreshUI();
      }

      if (
        resultData.ProductDetailList &&
        resultData.ProductDetailList.length > 0
      ) {
        resultData.ProductDetailList.forEach(m => {
          this.addProductDetailItem(m);
        });
        this.$refreshUI();
      }

      if (
        resultData.DeletedScanCodeList &&
        resultData.DeletedScanCodeList.length > 0
      ) {
        resultData.DeletedScanCodeList.forEach(m => {
          this.removeScanCodeItem(m.Code);
        });
        this.$refreshUI();
      }
      
      if (
        resultData.DeletedFailedScanCodeList &&
        resultData.DeletedFailedScanCodeList.length > 0
      ) {
        resultData.DeletedFailedScanCodeList.forEach(m => {
          this.removeFailedScanCodeItem(m.Code);
        });
        this.$refreshUI();
      }

      //console.log("resultData333",resultData);
    },    

    isExistCode(code) {
      try {
        if (!code) return false;

        var curCode = this.getScanCodeItem(code);
        if (curCode != null && curCode.Code == code) {
          return true;
        }
        return false;
      } catch (e) {
        alert("error:" + e);
        return false;
      }
    },

    async $openScan() {
      // if (typeof (IsWxReady) == "undefined" || !IsWxReady) {
      //     $.toast("检测中，请再次点击.", "forbidden");
      //     return;
      // }
      this.$scanWxCode((wxCode, wxRes) => {
        //$("#txtCode").val(wxCode);
        //$.alert(code);
        this.scanSuccess(wxCode);
      });
    },

    $scanWxCode(scanSuccess) {
      if (typeof wx == "undefined") {
        //$.alert("目前只支持微信扫码，请在微信中调用该功能。");
        return false;
      }

      //$.showLoading("正在扫码...");
      var timeout = 500;
      var scanner = this;
      setTimeout(() => {
        scanner._scanWxCode(scanSuccess);
      }, timeout);
    },

    _scanWxCode(scanSuccess) {
      //$.hideLoading();
      //$.toptip('开始扫码...', 500, 'success');
      var scanner = this;
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: (wxRes) => {
          // var str = JOSN.stringify(wxRes);
          // alert(str)
          var wxCode = wxRes.resultStr;
          if (wxCode && wxCode.indexOf(",") != -1) {
            wxCode = scanner.getBoxBarCode(wxRes);
            if (!wxCode) {
              //$.toast("正在扫描有效条码", "forbidden");
              scanner.$scanWxCode((wxCode, wxRes) => {
                scanner.scanSuccess(wxCode);
              });
              return false;
            }
          }
          if (scanner.isExistCode(wxCode)) {
            setTimeout(function() {
              scanner.$scanWxCode((wxCode, wxRes) => {
                scanner.scanSuccess(wxCode);
              });
            }, 2000);
            return false;
          }
          if (scanSuccess) {
            scanner.scanSuccess(wxCode, wxRes);
          }
        },
        fail: (wxRes) =>{
          //$.alert("扫描失败,原因:" + wxRes.errMsg);
          var msg = "扫描失败,请重试,原因:" + wxRes.errMsg;
          //$.toast(msg, "forbidden");
        }
      });
    },

    scanSuccess(code) {
      this.addScanCode(code);
      var scanner = this;

      setTimeout(function() {
        scanner.$scanWxCode((wxCode, wxRes) => {
          scanner.scanSuccess(wxCode);
        });
      }, 500);

      //$syncData();
    },

    getBoxBarCode(wxRes) {
      try {
        var serial = wxRes.resultStr.split(",");
        var wxCode = serial[serial.length - 1];
        var boxChar = wxCode.substr(3, 1);
        if (boxChar == "1") {
          return wxCode;
        }
        return false;
      } catch (e) {
        alert(e);
        return false;
      }
    }
  }
};
